export default __webpack_public_path__ + "static/media/title_main.407ec2ef.svg";